import { Group, rem, Text, TextInput } from '@mantine/core';
import { DateInput, type DateValue } from '@mantine/dates';
import dayjs from 'dayjs';
import { BiSolidDownArrow } from 'react-icons/bi';
import { dateFormatUI } from '@/index';
import { useEmployeeFormContext } from '../NewEmployeePage';

export const MealVoucherCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );

  const mealVoucher = form.values.cards.find(
    (card: { type: string }) => card.type === 'meal'
  );

  const handleDateChange = (iss: string, exp: string) => {
    const index = form.values.cards.findIndex(
      (card: { type: string }) => card.type === 'meal'
    );
    const updatedCards = [...form.values.cards];

    if (index !== -1) {
      updatedCards[index] = {
        ...updatedCards[index],
        issAt: iss,
        expAt: exp,
      };
    } else {
      const newMealVoucher = {
        type: 'meal',
        issAt: iss,
        expAt: exp,
        deposit: '',
      };
      updatedCards.push(newMealVoucher);
    }
    form.setFieldValue('cards', updatedCards);
  };

  const handleDepositChange = (newDeposit: string) => {
    const index = form.values.cards.findIndex(
      (card: { type: string }) => card.type === 'meal'
    );
    const updatedCards = [...form.values.cards];

    updatedCards[index] = {
      ...updatedCards[index],
      deposit: newDeposit,
    };

    form.setFieldValue('cards', updatedCards);
  };

  const setDeposit = (value: React.ChangeEvent<HTMLInputElement>) => {
    handleDepositChange(value.target.value);
  };

  const setIssAt = (d: DateValue) => {
    const date: string = dayjs(d).format();
    handleDateChange(
      date,
      mealVoucher ? dayjs(mealVoucher.expAt).format() : ''
    );
  };

  const setExpAt = (d: DateValue) => {
    const date: string = dayjs(d).format();
    handleDateChange(
      mealVoucher ? dayjs(mealVoucher.issAt).format() : '',
      date
    );
  };
  return (
    <div>
      <Text fw={700} size="lg" mt="lg">
        Stravenková karta
      </Text>

      <Group justify="space-between" grow align="start">
        <DateInput
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="datum vydání"
          label="Datum vydání"
          rightSection={icon}
          valueFormat={dateFormatUI}
          value={
            mealVoucher && dayjs(mealVoucher.issAt).isValid()
              ? dayjs(mealVoucher.issAt).toDate()
              : undefined
          }
          onChange={setIssAt}
          locale="cs"
        />

        <DateInput
          mt="sm"
          variant="filled"
          radius="md"
          label="Platnost"
          placeholder="platnost"
          disabled={!mealVoucher}
          rightSection={icon}
          valueFormat={dateFormatUI}
          value={
            mealVoucher && dayjs(mealVoucher.expAt).isValid()
              ? dayjs(mealVoucher.expAt).toDate()
              : undefined
          }
          onChange={setExpAt}
          locale="cs"
        />
      </Group>

      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="záloha"
        label="Záloha"
        disabled={!mealVoucher}
        value={mealVoucher?.deposit ? mealVoucher.deposit : ''}
        onChange={setDeposit}
      />
    </div>
  );
};
